import React from 'react';

import './styles.scss';

const Logout = () => {
  return (
    <div className="logout-main-container">
      <p className="logout-text">
        You have been <span className="red-text">logged out</span> successfully
      </p>
    </div>
  );
};

export default Logout;
